import { Alert } from "../context/alert";

export type EventMap = {
  alert: Omit<Alert, "id">;
};

class EventEmitter {
  private listeners: {
    [K in keyof EventMap]?: Array<(payload: EventMap[K]) => void>;
  } = {};

  on<K extends keyof EventMap>(
    event: K,
    listener: (payload: EventMap[K]) => void
  ) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event]!.push(listener);
  }

  emit<K extends keyof EventMap>(event: K, payload: EventMap[K]) {
    const listeners = this.listeners[event];
    if (listeners) {
      listeners.forEach((listener) => listener(payload));
    }
  }
  off<K extends keyof EventMap>(
    event: K,
    listener: (payload: EventMap[K]) => void
  ) {
    const listeners = this.listeners[event];
    if (listeners) {
      const index = listeners.indexOf(listener);
      if (index !== -1) {
        listeners.splice(index, 1);
      }
    }
  }
}

export const eventEmitter = new EventEmitter();
